export default __webpack_public_path__ + "static/media/troy-single.81a78fd2.svg";